import * as React from 'react';
import FilterList from 'material-ui/svg-icons/content/filter-list';
import ClearAll from 'material-ui/svg-icons/communication/clear-all';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const ActionBarTasks = ({ history }) => (
  <>
    <ColumnManager agenda={Agenda.TASKS} />
    <div style={{ marginLeft: 5 }}>
      <Button
        label={'Filtrovat Moje Úkoly'}
        key={'myTasks'}
        icon={<FilterList />}
        onClick={() => history.push(`/tasks/my`)}
        style={{ marginLeft: 5 }}
        type="button"
      />
    </div>
  </>
);

export const ActionBarMyTasks = ({ history }) => (
  <>
    <ColumnManager agenda={Agenda.MY_TASKS} />
    <div style={{ marginLeft: 5 }}>
      <Button
        label={'Zobrazit Všechny Úkoly'}
        key={'tasks'}
        icon={<ClearAll />}
        onClick={() => history.push(`/tasks`)}
        style={{ marginLeft: 5 }}
        type="button"
      />
    </div>
  </>
);



// WEBPACK FOOTER //
// ./src/modules/tasks/TasksGridButtons.tsx